<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="500">
      <v-card style="overflow: hidden;">
        <v-card-title>
          <span class="font-24 w-700 text-00A99D">หมายเหตุการยกเลิก</span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-form ref="notes">
            <v-textarea
              color="#00A99D"
              solo
              dense
              row="3"
              v-model="note"
              hide-details="auto"
              :rules="rule_note"
            >
            </v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-row class="mx-0">
            <v-col cols="6" class="py-5 pl-2">
              <v-btn
                outlined
                block
                style="border-radius: 20px 5px;"
                color="#FF8082"
                @click="(dialog = false), (note = '')"
                >ยกเลิก</v-btn
              >
            </v-col>
            <v-col cols="6" class="py-5 pr-2">
              <v-btn
                block
                dark
                depressed
                style="border-radius: 20px 5px;"
                color="#00A99D"
                @click="confirmDelete(data)"
                >บันทึก</v-btn
              >
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Sweetdialog ref="sweetDialog" />
  </div>
</template>

<script>
import Sweetdialog from "./Sweetdialog.vue";

export default {
  props: ["from"],
  components: {
    Sweetdialog,
  },
  data() {
    return {
      dialog: false,
      data: "",
      deliveryDrug: "",
      patientList: "",
      MeetPharmacist: "",
      note: "",
      rule_note: [(v) => !!v || "กรุณากรอกเหตุผลการยกเลิก"],
    };
  },
  methods: {
    openDialog(item) {
      // console.log('item', item);
      this.dialog = true;
      this.data = item;
      this.note = ''
    },
    confirmDelete(item) {
      if (this.from === "deliveryDrug") {
        this.deliveryDrug = item;
      } else if (this.from === "patientList") {
        this.patientList = item;
      } else if (this.from === "MeetPharmacist") {
        this.MeetPharmacist = item;
      } else {
        this.deliveryDrug = "";
        this.patientList = "";
        this.MeetPharmacist = "";
      }
      this.$swal
        .fire({
          title:
            "<span style='color: black;font-size: 24px;font-family: Sarabun;font-weight: 500;'><b>ยกเลิกรายการนี้หรือไม่</b></span>",
          icon: "warning",
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonText:
            "<span style='color: #F5222D;font-size: 16px;font-family: Sarabun, sans-serif'>ยกเลิก</span>",
          cancelButtonColor: "#FFFFFF",
          showConfirmButton: true,
          confirmButtonText:
            "<span style='font-size: 16px;font-family: Sarabun, sans-serif;'>ยืนยัน</span>",
          confirmButtonColor: "#00A99D",
          allowOutsideClick: false,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.cancel();
          } else if (result.isDenied) {
            this.dialog = false;
          }
        });
    },
    cancel() {
      if (!this.$refs.notes.validate()) {
        const data = {
          title:
            "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>กรุณากรอกเหตุผลการยกเลิก</span>",
          icon: "error",
          showConfirmButton: false,
          confirmButtonText: "ปิด",
          confirmButtonColor: "#00A99D",
          timer: 1500,
        };
        this.$refs.sweetDialog.open(data);
        return;
      } else {
        if (this.from === "deliveryDrug") {
          try {

            var body = {
              reference_id: this.data.reference_id,
              note: this.note,
              staff_id: this.data.one_id_user
            }

            this.axios.post(process.env.VUE_APP_BACKEND_URL + `/v1/transport/cancel_transport`, body)
            .then((res) => {
                if (res.data.result === "success") {
                  this.$swal({
                    title:"<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>ยกเลิกข้อมูลสำเร็จ</span>",
                    icon: "success",
                    showConfirmButton: false,
                    confirmButtonText: "ปิด",
                    confirmButtonColor: "#00A99D",
                    timer: 1500,
                  })
                  this.note = ''
                  this.dialog = false;
                  this.$emit("close");
                } else {
                  this.$swal({
                    title:"<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>ยกเลิกข้อมูลไม่สำเร็จ</span>",
                    icon: "error",
                    showConfirmButton: false,
                    confirmButtonText: "ปิด",
                    confirmButtonColor: "#00A99D",
                    timer: 1500,
                  })
                  this.note = ''
                  this.dialog = false;
                  this.$emit("close");
                }
            });
          } catch (err) {
            console.log(err);
            const data = {
              title:
                "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดพลาด</span>",
              icon: "error",
              showConfirmButton: false,
              confirmButtonText: "ปิด",
              confirmButtonColor: "#3085d6",
              timer: 1500,
            };
            this.$refs.sweetDialog.open(data);
          }
        } else if (this.from === "patientList") {
          try {
            const params = new URLSearchParams();
            params.append("register_id", this.patientList.register_id);

            this.axios.post(`${process.env.VUE_APP_BACKEND_URL}/v1/pharma/cancel_regis?${params}`,
                {
                  status: "4",
                  note: this.note,
                  updated_by: sessionStorage.account_id
                },
              ).then((res) => {
                if (res.data.code == 200 && res.data.result == "success") {
                  const data = {
                    title:
                      "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>ยกเลิกสำเร็จ</span>",
                    icon: "success",
                    showConfirmButton: false,
                    confirmButtonText: "ปิด",
                    confirmButtonColor: "#3085d6",
                    timer: 1500,
                  };
                  this.$refs.sweetDialog.open(data);
                  this.dialog = false;
                  this.$emit("close");
                }
              });
          } catch (err) {
            console.log(err);
            const data = {
              title:
                "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดพลาด</span>",
              icon: "error",
              showConfirmButton: false,
              confirmButtonText: "ปิด",
              confirmButtonColor: "#3085d6",
              timer: 1500,
            };
            this.$refs.sweetDialog.open(data);
          }
        } else if (this.from === "MeetPharmacist") {
          try {
            this.axios.post(`${process.env.VUE_APP_BACKEND_URL}/v1/meetpharma/update_conference_status`,
            {
              appointment_id: this.data.appointment_id,
              actions_type: 'cancel',
              note_cancel: this.note,
            }).then((res) => {
              // console.log(res);
              if (res.data.code == 200 && res.data.result == "success") {
                this.$swal({
                  title:"<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>ยกเลิกสำเร็จ</span>",
                  icon: "success",
                  showCloseButton: false,
                  showConfirmButton: false,
                  confirmButtonColor: "#00A99D",
                  timer: 3000,
                }).then(() => {
                  this.dialog = false;
                  this.$emit("close");
                })
              } else {
                this.$swal({
                  title:
                    "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>ยกเลิกไม่สำเร็จ</span>",
                  icon: "error",
                  showCloseButton: false,
                  showConfirmButton: false,
                  background: "white",
                  timer: 3000,
                });
              }
            })
          } catch(err) {
            console.log(err);
          }
        } else {
          this.$swal({
            title:
              "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดพลาด</span>",
            icon: "error",
            showCloseButton: false,
            showConfirmButton: false,
            background: "white",
            timer: 3000,
          });
        }
      }
    },
  },
};
</script>

<style scoped>
::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}
</style>
